export default __webpack_public_path__ + "static/media/TrustedDev-activeTab.149088ee.svg";